/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ud_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID & ULID Inspector — Validate and Decode | Toolverse`)
};

const es_ud_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspector UUID e ULID — Valida y Decodifica | Toolverse`)
};

const de_ud_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID & ULID Inspector — Validieren und Decodieren | Toolverse`)
};

const nl_ud_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID & ULID Inspector — Valideer en decodeer | Toolverse`)
};

const fr_ud_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecteur UUID et ULID — Valider et décoder | Toolverse`)
};

const it_ud_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ispettore UUID e ULID — Convalida e Decodifica | Toolverse`)
};

const pt_br2_ud_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor de UUID e ULID — Valide e Decodifique | Toolverse`)
};

const pt_ud_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor de UUID e ULID — Valide e Descodifique | Toolverse`)
};

const ja_ud_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID & ULID インスペクター — 検証とデコード | Toolverse`)
};

const zh_ud_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID 与 ULID 检查器 — 验证与解码 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ud_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ud_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ud_meta_title", locale)
	if (locale === "en") return en_ud_meta_title(inputs)
	if (locale === "es") return es_ud_meta_title(inputs)
	if (locale === "de") return de_ud_meta_title(inputs)
	if (locale === "nl") return nl_ud_meta_title(inputs)
	if (locale === "fr") return fr_ud_meta_title(inputs)
	if (locale === "it") return it_ud_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_ud_meta_title(inputs)
	if (locale === "pt") return pt_ud_meta_title(inputs)
	if (locale === "ja") return ja_ud_meta_title(inputs)
	return zh_ud_meta_title(inputs)
};